
<div class="progressbardiv">
  @if (progressPercent!=null) {
    <mat-progress-bar [value]="progressPercent" mode="determinate"></mat-progress-bar>
  }
</div>

<div class="row" [ngClass]="{
  'isPaused': !isRunning,
  'isError': errortext
}">

  <div class="cancelbutton">
    <button mat-button (click)="onClear()" title="Abbruch" ><i class="material-icons">clear</i></button>
  </div>
  <div class="filename">
    {{file.name}}
  </div>
  @if (!errortext) {
    <div class="filesize">
      {{file.size | fileSize}}
    </div>
  }
  @if (!errortext) {
    <div class="uploadState">
      @if (!isRunning) {
        <span>wartet...</span>
      }
      @if (isRunning) {
        <span>{{progressPercent}}%</span>
      }
    </div>
  }
  @if (errortext) {
    <div class="errorDiv">
      <span class="errorText">FEHLER: {{errortext}}</span>
    </div>
  }
</div>
